import {
  Component,
  OnInit,
  NgZone
} from '@angular/core';
import { MainPageService } from './../../../main-page.service';
import { Subject } from 'rxjs';
import { BasicDictionaryModel } from '../../../../models/dictionaries/basic-dictionary.model';
import { FormGroup, FormBuilder } from '@angular/forms';
import { WorkingPiperingModel } from '../../../../models/settings/working-pipering.model';
import { PipeRingModel } from '../../../../models/parts/pipering.model.';

@Component({
  selector: 'app-pipe-to-piperings-managment',
  template: `<div *ngIf="pipeToPiperingData !== undefined && pipeToPiperingData !== null">
    <div class="row" style="padding-left: 12px;"></div>
    <button type="button" class="btn btn-danger red-button" (click)="returnHandler()">Return</button>
    <button type="submit" class="btn btn-primary save-button" [disabled]="ctrl.invalid || ctrl2.invalid || ctrl3.invalid"
        (click)="save()">Save</button>
    <div class="row">
        <div class="col-6" style="line-height: 30px; padding-top: 30px;">
            <div class="display-flex">
                <div class="col-3">Pipe Function:
                </div>
                <select name="" id="" [(ngModel)]="pipeToPiperingData.pipeFunctionId" #ctrl="ngModel" required>
                    <option [value]="null" disabled hidden></option>
                    <option *ngFor="let pipeFunction of pipeFunctionsArray | sortByName" [(value)]="pipeFunction.id">{{pipeFunction.name}}</option>
                </select>
                <br>
            </div>
            <div class="display-flex">
                <div class="col-3">Pipe Material Type:
                </div>
                <select name="" id="" [(ngModel)]="pipeToPiperingData.pipeMaterialTypeId" #ctrl2="ngModel" required>
                    <option [value]="null" disabled hidden></option>
                    <option *ngFor="let pipeMaterialType of pipeMaterialTypesArray | sortByName" [(value)]="pipeMaterialType.id">{{pipeMaterialType.name}}</option>
                </select>
            </div>
            <div class="display-flex">
                <div class="col-3">Orientation:
                </div>
                <select name="" id="" [(ngModel)]="pipeToPiperingData.orientation" #ctrl3="ngModel" required>
                    <option [value]="null" disabled hidden></option>
                    <option *ngFor="let orientation of orientationsArray" [(value)]="orientation.id">{{orientation.name}}</option>
                </select>
            </div>
        </div>
    </div>
    <div class="col-3">
        <kendo-grid style="border: none" [data]="workingPiperingsArray" (add)="addHandlerForPiperingData($event)"
            (save)="saveHandlerForPiperingData($event)" (cancel)="cancelHandlerForPiperingData($event)" (edit)="editHandlerForPiperingData($event)"
            (remove)="removeHandler($event)">
            <ng-template kendoGridToolbarTemplate>
                <div class="display-flex">
                    <button kendoGridAddCommand [disabled]="!canAddRowToPiperingsGrid" class="btn add-button light-steel-shadow"
                        style="position: absolute; right: 15px;" type="button" title="add">
                        <i class="fa fa-plus" click></i> Add</button>
                </div>
            </ng-template>
            <kendo-grid-column field="piperingName" title="Pipe ring" width="120">
                <ng-template kendoGridEditTemplate let-dataItem="dataItem">
                    <!-- <input [(ngModel)]="dataItem.ProductName" kendoGridFocusable name="ProductName" class="k-textbox" required/> -->
                    <select #pipering style="width:120px;" name="PiperingSelect" [(ngModel)]="dataItem._piperingId"
                        required>
                        <option *ngFor="let pipering of piperingsArray" [(value)]="pipering._id">{{pipering.name}}</option>
                    </select>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column title="" width="30">
                <ng-template kendoGridCellTemplate>
                    <div class="display-flex">
                        <!--MAGIC DO NOT TOUCH DISABLE FUNCTION-->
                        <button kendoGridEditCommand [disabled]="!canAddRowToPiperingsGrid" class="attributesBtn" title="Edit">
                            <i class="material-icons">&#xE3C9;</i>
                        </button>
                        <button kendoGridRemoveCommand [disabled]="!canAddRowToPiperingsGrid" class="attributesBtn btn-remove"
                            data-toggle="modal" data-target="#confirmationModal" title="Remove">
                            <i class="material-icons">&#xE5CD;</i>
                        </button>
                        <button kendoGridSaveCommand class="attributesBtn" title="Save">
                            <i class="material-icons">&#xE876;</i>
                        </button>
                        <button kendoGridCancelCommand class="attributesBtn" title="Cancel">
                            <i class="material-icons">&#xE5C9;</i>
                        </button>
                    </div>
                </ng-template>
            </kendo-grid-column>
        </kendo-grid>
    </div>
</div>

<!-- Delete Modal -->
<div class="modal" id="confirmationModal">
    <div class="modal-dialog">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
                <span class="modal-label">Do you want to delete this Working pipering?</span>
            </div>

            <!-- Modal footer -->
            <div class="modal-footer">
                <button type="button" class="btn btn-danger red-button" data-dismiss="modal">Cancel</button>
                <button type="submit" class="btn btn-primary save-button" data-dismiss="modal" (click)="removePipering()">Delete</button>
            </div>
        </div>
    </div>
</div>`,
  styles: [`.regularObjectBorder{border-width:1px;border-style:solid}.justTopBorder{border-bottom:0;border-left:0;border-right:0}.justRightBorder{border-bottom:0;border-left:0;border-top:0}.justBottomBorder{border-right:0;border-left:0;border-top:0}#tabContent{font-size:11px;border-color:#dddd}.modal-label{width:168px}hr{margin-top:0}#variantsGrid{margin-left:17px;border-color:#dddd}.delete-button{height:23px;width:23px;margin-left:3px;background-color:#d0021b;color:#fff;font-size:12px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;border-radius:2px;cursor:pointer}.configure-button{height:23px;margin-left:3px;background-color:#4a8bb7;color:#fff;font-size:12px;padding:3px 14px;font-weight:300;letter-spacing:1.1px;box-shadow:0 2px 10px 0 rgba(0,0,0,.06);font-family:Roboto,sans-serif;text-transform:uppercase;outline:0;border:none;margin-bottom:6px;border-radius:2px;cursor:pointer}.configure-button:disabled{background-color:#999;cursor:default}.step-file{font-size:14px;text-align:center;margin-bottom:10px;font-weight:700}#stpFileDiv{margin-left:auto;margin-right:auto}#variantsTabGrid{border:0;margin-top:26px;border-top:1px solid #ddd}.extra-padding-top{padding-top:10px}.mat-header-cell{font-weight:700}.variantBtn{background-color:#ddd;border:none;padding:6px 18px;outline:0;color:#534f53;cursor:pointer}.variants-header{margin:28px 0 5px;display:flex;justify-content:space-between}.table-label{font-size:16px}.tableCurrentVariant{font-size:14px;border-color:#708090}.borderGray{border-color:#a9a9a9}.borderGray:last-child{border-right:none}.mat-header-row{border-color:#dddd}.highlighted{background-color:#fff!important}.display-flex{display:flex;align-items:center;margin-bottom:10px}.save-button{margin-right:10px}`]
})

export class PipeToPiperingsManagmentComponent implements OnInit {
  public pipeToPiperingData: any;
  public isPipeToPiperingNew: boolean = false;
  public stateSubject: Subject<any> = new Subject();
  public pipeFunctionsArray: BasicDictionaryModel[] = [];
  public pipeMaterialTypesArray: BasicDictionaryModel[] = [];
  public workingPiperingsArray: WorkingPiperingModel[] = [];
  public editedWorkingPiperingData: WorkingPiperingModel;
  public canAddRowToPiperingsGrid = true;
  private piperingsOpenedGridRows: number = 0;
  public isPiperingsGridInChangeMode = false;
  public currentOpenRow: number;
  public formGroup: FormGroup;
  public rowNumber: number;
  private removeData: any;
  public piperingsArray: PipeRingModel[] = [];
  public orientationsArray: any[] = [{ id: 0, name: 'All' }, { id: 1, name: 'Veritcal' }, { id: 2, name: 'Horizontal' }];

  constructor(private mainPageService: MainPageService, private formBuilder: FormBuilder) { }

  public ngOnInit(): void {
    this.loadData();
  }

  loadData(): void {
    this.mainPageService.loadAllPipeFunctions().subscribe((res) => {
      this.pipeFunctionsArray = res;
    });
    this.mainPageService.loadAllPipeMaterialTypes().subscribe((res) => {
      this.pipeMaterialTypesArray = res;
    });
    this.mainPageService.loadAllPiperings().subscribe((res) => {
      this.piperingsArray = res;
    });
  }

  private loadWorkingPiperings() {
    this.mainPageService.loadWorkingPiperings(this.pipeToPiperingData._id).subscribe((res) => {
      this.workingPiperingsArray = res;
    });
  }

  public showManagmentPage(sender, isNew) {
    this.pipeToPiperingData = sender;
    this.isPipeToPiperingNew = isNew;
    this.loadWorkingPiperings();
  }

  save(): void {
    this.pipeToPiperingData.pipeFunctionName = this.pipeFunctionsArray.find(x => x.id == this.pipeToPiperingData.pipeFunctionId).name;
    this.pipeToPiperingData._pipeFunctionId = this.pipeFunctionsArray.find(x => x.id == this.pipeToPiperingData.pipeFunctionId)._id;
    this.pipeToPiperingData.pipeMaterialTypeName =
      this.pipeMaterialTypesArray.find(x => x.id == this.pipeToPiperingData.pipeMaterialTypeId).name;
    this.pipeToPiperingData._pipeMaterialTypeId =
      this.pipeMaterialTypesArray.find(x => x.id == this.pipeToPiperingData.pipeMaterialTypeId)._id;
    this.mainPageService.updatePipeToPiperingInDb(JSON.stringify(this.pipeToPiperingData)).subscribe(() => { });
    if (this.isPipeToPiperingNew) {
      this.isPipeToPiperingNew = false;
    }
  }

  returnHandler() {
    if (this.isPipeToPiperingNew) {
      this.mainPageService.removePipeToPipering(this.pipeToPiperingData._id).subscribe(() => { });
      this.mainPageService.deletePipeToPiperingSubject.next(this.pipeToPiperingData._id);
      this.pipeToPiperingData = null;
    }
    this.stateSubject.next(this.pipeToPiperingData);
    this.pipeToPiperingData = null;
  }

  public editHandlerForPiperingData({ sender, rowIndex }) {
    this.canAddRowToPiperingsGrid = false;

    this.piperingsOpenedGridRows++;
    this.isPiperingsGridInChangeMode = true;
    this.currentOpenRow = rowIndex;
    this.formGroup = this.createFormGroupForPiperingsData();
    sender.editRow(rowIndex, this.formGroup);
  }

  public cancelHandlerForPiperingData({ sender, rowIndex }) {
    if (this.isPiperingsGridInChangeMode) {
      this.piperingsOpenedGridRows--;
      sender.closeRow(rowIndex);
      if (this.piperingsOpenedGridRows === 0) {
        this.isPiperingsGridInChangeMode = false;
      }
      this.canAddRowToPiperingsGrid = true;
    } else {
      this.piperingsOpenedGridRows--;
      this.workingPiperingsArray = this.workingPiperingsArray.filter(
        item => item !== this.workingPiperingsArray[rowIndex]
      );
      sender.closeRow(rowIndex);
      this.canAddRowToPiperingsGrid = true;
    }

  }

  public saveHandlerForPiperingData({ sender, formGroup, rowIndex }) {
    this.rowNumber = rowIndex;
    if (this.isPiperingsGridInChangeMode) {
      if (this.formGroup.valid
      ) {
        this.piperingsOpenedGridRows--;

        this.overwriteDataInGrid(rowIndex);
        sender.closeRow(rowIndex);
        this.canAddRowToPiperingsGrid = true;
        if (this.piperingsOpenedGridRows === 0) {
          this.isPiperingsGridInChangeMode = false;
        }
        // this.changeElementUnitsToSI(rowIndex);
        this.editedWorkingPiperingData = this.workingPiperingsArray[rowIndex];
        this.saveEditedPipering();
      }
    } else {
      if (this.formGroup.valid
      ) {
        this.piperingsOpenedGridRows--;


        this.overwriteDataInGrid(rowIndex);
        sender.closeRow(rowIndex);
        this.canAddRowToPiperingsGrid = true;
        if (this.piperingsOpenedGridRows === 0) {
          this.isPiperingsGridInChangeMode = false;
        }
        // this.changeElementUnitsToSI(rowIndex);
        this.editedWorkingPiperingData = this.workingPiperingsArray[rowIndex];
        this.saveNewPipering();
      }
    }
  }

  public addHandlerForPiperingData({ sender }) {
    this.piperingsOpenedGridRows++;
    this.workingPiperingsArray.push(new WorkingPiperingModel(null, null, this.pipeToPiperingData.id, this.pipeToPiperingData._id));
    this.canAddRowToPiperingsGrid = false;
    this.currentOpenRow = this.workingPiperingsArray.length - 1;
    sender.editRow(
      this.workingPiperingsArray.length - 1,
      this.formGroup = this.createFormGroupForPiperingsData(

      )
    );
  }

  public removeHandler({ dataItem }) {
    this.removeData = dataItem;
  }

  public createFormGroupForPiperingsData(): FormGroup {
    return this.formBuilder.group({
    });
  }

  overwriteDataInGrid(rowIndex) {
    // this.workingPiperingsArray[rowIndex]._piperingId =
    //   this.piperingsArray.find(x => x.id == this.workingPiperingsArray[rowIndex].piperingId)._id;
    this.workingPiperingsArray[rowIndex].piperingName =
      this.piperingsArray.find(x => x._id == this.workingPiperingsArray[rowIndex]._piperingId).name;
  }

  saveNewPipering() {
    console.log(this.editedWorkingPiperingData);
    this.mainPageService.addNewWorkingPiperingIntoDb(
      JSON.stringify(this.workingPiperingsArray[this.rowNumber])).subscribe((response) => {
        this.editedWorkingPiperingData._id = response._id;
        this.editedWorkingPiperingData.id = response.id;
        this.workingPiperingsArray[this.rowNumber] = this.editedWorkingPiperingData;
      });
  }

  saveEditedPipering() {
    console.log(this.workingPiperingsArray[this.rowNumber]);
    this.mainPageService.updateWorkingPiperingInDb(JSON.stringify(this.editedWorkingPiperingData)).subscribe(() => { });
  }

  public removePipering() {
    let index;
    for (let i = 0; i < this.workingPiperingsArray.length; i++) {
      if (this.workingPiperingsArray[i]._id === this.removeData._id) {
        index = i;
      }
    }
    this.deletePipePipering(this.workingPiperingsArray[index]);
  }

  deletePipePipering(size) {
    this.mainPageService.removeWorkingPipering(size._id).subscribe(() => { }, () => { });
    this.mainPageService.deleteWorkingPiperingSubject.next(size._id);
  }
}
